// extracted by mini-css-extract-plugin
export default {"st0":"CodeIcon_st0__zYGkU","st1":"CodeIcon_st1__UCc0u","st2":"CodeIcon_st2__4AbkD","st3":"CodeIcon_st3__JNYVQ"};